import { HTTPError } from 'ky';

export const getHTTPError = (error: any) =>
  error instanceof HTTPError ? error.message : undefined;
